if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * Load HTML via an AJAX call
         *
         * Replaces container element with container from target html. Compares container tagname, classname and id.
         * @param container - jQuery representation of container element
         * - should contain attribute data-url=url_of_target_html
         *
         * NB URL of page to load should be in the same domain to avoid cross-domain security issues
         */
        ZZ.Loader = function(container) {
            var base = this;
            base.container = container;
            base.url = container.attr("data-url") || "/";

            base.loadUrl(base.url);
        };

        ZZ.Loader.prototype = {
            loadUrl: function(url) {
                var base = this,
                    className = base.container.attr("class"),
                    tagName = base.container.prop("tagName"),
                    id = base.container.attr("id"),
                    tempUrl = url;
                // add unique number to url to prevent cashing
                tempUrl += url.indexOf("?") === -1 ? "?" : "&";
                tempUrl += new Date().valueOf();

                $.ajax({
                    url: tempUrl,
                    context: base.container,
                    dataType: "html",
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                    success: function(data) {
                        var tempDom = $("<div>").append(data);

                        var newContainer = $(
                            `.wrapper > .${className}`,
                            tempDom
                        );

                        // Insert HTML
                        base.container.replaceWith(newContainer);

                        // init
                        ZZ.init(newContainer.get(0));
                    },
                    error: function(error) {
                        console.log(
                            "Something has gone wrong with the ajax html loading",
                            error
                        );
                    }
                });
            }
        };
    })(jQuery);
}
